export const tickerTapeData = [
  {
    id: 1,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 2,
    name: "BANKNIFTY",
    price: "11,502.10",
    percent: "0.10",
  },
  {
    id: 3,
    name: "SENSEX",
    price: "23,502.10",
    percent: "-9.10",
  },
  {
    id: 4,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 5,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 6,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 7,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 8,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 9,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 10,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 11,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
  {
    id: 12,
    name: "NIFTY",
    price: "23,502.10",
    percent: "0.10",
  },
];
